import { Create, useNotify, useRedirect, useResourceContext } from 'react-admin';

import { ProductForm } from './ProductForm';
import { transformProductInput } from './json';

export const ProductCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const resource = useResourceContext();

  const onSuccess = () => {
    notify('Saved new Product', { type: 'success' });
    redirect('list', resource);
  };

  return (
    <Create transform={transformProductInput} mutationOptions={{ onSuccess }}>
      <ProductForm title="Create Product" />
    </Create>
  );
};
